<script>
/**
 * ****************************************************************************
 * @description     :   Input Radio Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import _ from 'lodash-uuid';

/**
 * Define content of input radio component
 */
var AnsRadioButton = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: String | Number,
        modelValue: String | Number,
        isDisabled: Boolean,
        isDisabledIndex: String,
        isRequired: Boolean,
        remarks: Array,
        options: Array,
        onChange: Function
    },
    emits: ['update:modelValue'],
    computed: {
        vewValue() {
            return this.modelValue != null && this.modelValue != undefined
                ? this.modelValue
                : this.value;
        }
    },
    data() {
        return {
            newId: _.uuid()
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        }
    },
    methods: {
        /**
         * select item and checked input radio
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        selectedOption(val) {
            return this.vewValue + '' == val + '';
        },
        /**
         * click update item input radio
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        updateInput(e) {
            const vewValue = e.target.value;
            if (vewValue + '' == this.vewValue + '') {
                return;
            }
            // eslint-disable-next-line no-undef
            $(`.${this.newId}`).RemoveError();
            this.$emit('update:modelValue', vewValue);
            if (this.onChange) {
                this.onChange(e, vewValue);
            }
        }
    }
};
export default AnsRadioButton;
</script>
